// The active links that only make sense while the drop is open: the apply and
// checkout flows, and the anchor to the product cards carrying the cart buttons.
const isPurchaseLink = (link: string | null | undefined) =>
	!!link &&
	(link.includes('/apply') || link.includes('/checkout') || link === '#cards');

// A button leading to the purchase flow has nowhere to go once the drop is not
// live. With an inactive link it swaps to that instead; without one it is hidden.
export const shouldHideDropButton = (
	button:
		| {
				link?: string | null | undefined;
				inactive_link?: string | null | undefined;
		  }
		| null
		| undefined,
	{
		showCardButtons,
		showCardCartButton,
	}: { showCardButtons: boolean; showCardCartButton: boolean }
) =>
	(!showCardCartButton || !showCardButtons) &&
	!button?.inactive_link &&
	isPurchaseLink(button?.link);
